import imageCompression from 'browser-image-compression';

/** Ukuran maksimal setelah kompresi (MB) */
export const MAX_IMAGE_MB = 1.5;

/** Ukuran file sumber maksimal sebelum ditolak (hindari crash browser) */
export const MAX_SOURCE_IMAGE_MB = 40;

const optionsBase = (maxW) => ({
  maxSizeMB: MAX_IMAGE_MB,
  maxWidthOrHeight: maxW,
  useWebWorker: true,
  fileType: 'image/jpeg',
});

/**
 * Kompres gambar agar idealnya ≤ MAX_IMAGE_MB (JPEG).
 * @param {File} file
 * @returns {Promise<File>}
 */
export async function compressImageForUpload(file) {
  if (!file || !file.type.startsWith('image/')) {
    return file;
  }

  if (file.size > MAX_SOURCE_IMAGE_MB * 1024 * 1024) {
    throw new Error(
      `File terlalu besar (maks ${MAX_SOURCE_IMAGE_MB}MB sebelum kompresi). Pilih gambar yang lebih kecil.`
    );
  }

  let compressed = await imageCompression(file, optionsBase(2560));

  if (compressed.size > MAX_IMAGE_MB * 1024 * 1024) {
    compressed = await imageCompression(file, optionsBase(1920));
  }
  if (compressed.size > MAX_IMAGE_MB * 1024 * 1024) {
    compressed = await imageCompression(file, optionsBase(1280));
  }
  if (compressed.size > MAX_IMAGE_MB * 1024 * 1024) {
    compressed = await imageCompression(file, optionsBase(960));
  }

  const baseName = file.name.replace(/\.[^.]+$/, '') || 'image';
  return new File([compressed], `${baseName}.jpg`, {
    type: 'image/jpeg',
    lastModified: Date.now(),
  });
}
